import {PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = { value: "" };

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    dataSet: (state,action) => {
      state.value = action.payload;
    },
    dataClear: (state) => {
      state.value = "";
    },
  },
});
export const {dataSet,dataClear}=dataSlice.actions;
export default dataSlice.reducer;